<template>
  <div class="prepare-call-view">
    <modal-frame :showModalFlag="modalDisplay" :position="'fullscreen'">
      <div class="modal-body">
        <div class="information-block">
          <div class="sender-column">
            <user-portrate :target="currentUser" :displaySize="'small'"/>
            <div class="sender-name" :class="senderNameSizeClass">
              {{ currentUser.name }}
            </div>
          </div>
          <div class="arrow-column">
            <img src="/images/down_white_arrow.svg"/>
          </div>
          <div class="attendees-column">
            <div class="attendee-info" 
              v-for="(attendee, index) in attendees" 
              :key="'precatd' + attendee.id"
              :class="{ last: index + 1 === attendees.length }">
              <div class="portrate-block">
                <user-portrate :target="attendee" :displaySize="'middle'"/>
              </div>
              <div class="name-block">
                <div class="name" :class="attendeeNameSizeClass(attendee)">{{ attendee.name }}</div>
                <div class="description" v-html="attendeeDescriptionHTML(attendee)"></div>
              </div>
            </div>
          </div>
          <div class="add-attendee-column" @click="addAttendee">＋ 通話先追加/削除</div>
        </div>
        <div class="controll-block">
          <div class="cancel-controll" @click="cancelCall">
            <img src="/images/call_cancel_icon.svg"/>
            <span class="caption">キャンセル</span>
          </div>
          <div class="start-call-controll" @click="startCall">
            <img src="/images/call_icon.svg" />
            <span class="caption">通話開始</span>
          </div>
          <div class="mic-controll" @click="toggleMute">
            <img src="/images/mic_on_icon.svg" v-show="!micMute" />
            <img src="/images/mic_off_icon.svg" v-show="micMute" />
          </div>
          <div class="camera-controll" @click="toggleCamera">
            <img src="/images/video_on_icon.svg" v-show="!cameraOff" />
            <img src="/images/video_off_icon.svg" v-show="cameraOff" />
          </div>
        </div>
      </div>
    </modal-frame>
    <attendee-select-modal
      :attendees="attendees"
      :modalDisplay="attendeeSelectModalDisplay"
      v-on:selectFinishEvent="attendeeSelected"
      />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import AttendeeSelectModal from '@/components/appView/prepareCall/AttendeeSelectModal.vue'
import UserPortrate from '@/components/appView/common/UserPortrate.vue'
import ModalFrame from '@/components/common/ModalFrame.vue'

export default {
  name: 'PrepareCallView',

  components: {
    AttendeeSelectModal,
    UserPortrate,
    ModalFrame,
  },

  props: {
    modalDisplay: Boolean,
    presentedAttendees: Array,
  },

  emits: [
    'cancelCallEvent',
    'callStartedEvent',
    'parameterErrorEvent',
  ],

  data () {
    return {
      attendees: [],
      callbackURL: null,
      micMute: false, // TODO: デバイスから初期状態を取得する
      cameraOff: false, // TODO: デバイスから初期状態を取得する
      attendeeSelectModalDisplay: false,
    }
  },

  watch: {
    '$route': { handler: 'storeQuery', immediate: true },
    presentedAttendees: { handler: 'initAttendee', immediate: true },
    // device: { handler: 'fireFinishedEvent', immediate: true }
  },

  computed: {
    ...mapState({
      currentUser: state => state.user.currentUser,
      currentDevice: state => state.user.currentDevice,
      availableUsers: state => state.user.users,
      addressBook: state => state.addressBook.addressCategories,
    }),

    senderNameSizeClass () {
      if (this.currentUser.name.length < 5) {
        return 'large'
      } else if (this.currentUser.name.length < 10) {
        return 'middle'
      } else {
        return 'small'
      }
    },
  },

  methods: {
    ...mapActions({
      fetchCurrentSignin: 'user/fetchCurrentSignin',
      fetchAvailableUsers: 'user/fetchAvailableUsers',
      switchAccount: 'user/switchAccount',
      fetchUserByNarrativePhoneID: 'user/fetchByNarrativePhoneID',
      fetchAddressBook: 'addressBook/fetch',
    }),

    attendeeNameSizeClass (attendee) {
      if (attendee.name.length < 5) {
        return 'large'
      } else if (attendee.name.length < 10) {
        return 'middle'
      } else {
        return 'small'
      }
    },

    attendeeDescriptionHTML (attendee) {
      if (attendee.description) {
        return attendee.description.replace(/\n/gi, '<br />')
      }
      return ''
    },

    async storeQuery () {
      console.log(this.$route.query)
      await this.fetchCurrentSignin()
      await this.fetchAvailableUsers()
      // pathでアクセスした場合
      if (this.$route.path === '/phone_call') {
        let requestValid = true
        let errorMessage = ''
        if (this.$route.query.attendees) {
          // attendeesをカンマで区切って取得
          console.log(this.$route.query.attendees)
          // fetchUserByNarrativePhoneIDで取得、デバイス登録ユーザーがいないかチェック。
          let attendeeIDList = this.$route.query.attendees.split(',')
          for(let attID of attendeeIDList) {
            console.log(attID)
            let attendee = await this.fetchUserByNarrativePhoneID({ narrativePhoneID: attID })
            if (attendee) {
              this.attendees.push(attendee)
            }
          }
          if (this.attendees.length <= 0) {
            requestValid = false
            errorMessage += '通話先が存在しません。'
          }
        } else {
          requestValid = false
          errorMessage += '通話先が存在しません。'
        }
        if (this.$route.query.callback_url) {
          this.callbackURL = this.$route.query.callback_url
        }
        if (this.$route.query.sender_id) {
          // check current_user and available_users
          let targetUser = null
          if (this.currentUser.narrative_phone_id === this.$route.query.sender_id) {
            // console.log('target user same as current user. current:' + this.currentUser.narrative_phone_id + ' target: ' + this.$route.query.sender_id)
            targetUser = this.currentUser
          } else {
            for(let user of this.availableUsers) {
              if (user.narrative_phone_id === this.$route.query.sender_id) {
                targetUser = user
              }
            }
            if (targetUser) {
              // console.log('gonna switch user.....')
              this.switchAccount(targetUser.account_name).then(() => {
                // console.log('user switched. to: ' + targetUser.account_name)
                this.fetchCurrentSignin()
              })
            } else {
              requestValid = false
              errorMessage = '指定された発信者アカウントが正しくありません。'
            }
          }
        } else {
          requestValid = false
          errorMessage = '発信者アカウントが指定されていません。'
        }
        if (!requestValid) {
          // display error message and close modal,
          this.$emit('parameterErrorEvent', errorMessage)
        }
      } else {
        this.attendees = this.presentedAttendees.map(attendee => ({ ...attendee }))
      }
    },

    initAttendee () {
      if (this.presentedAttendees.length > 0) {
        this.attendees = this.presentedAttendees
      }
      this.micMute = false
      this.cameraOff = false
    },

    addAttendee () {
      // TODO: showAddressModal
      this.attendeeSelectModalDisplay = true
    },

    attendeeSelected (selectedAttendees) {
      // アドレス帳に入っていない通話先はモーダル内で変更されないのでそのままクローンしてOK
      this.attendees = selectedAttendees.map(attendee => ({ ...attendee }))
      this.attendeeSelectModalDisplay = false
    },

    cancelCall () {
      // Move to before
      this.$emit('cancelCallEvent')
    },

    startCall () {
      // send native event.
      let callInformation = {
        sender_id: { narrative_phone_id: this.currentUser.narrative_phone_id, name: this.currentUser.name },
        attendees: this.attendees.map((att) => ({ narrative_phone_id: att.narrative_phone_id, name: att.name })),
        callback_url: this.callbackURL,
        mic_mute: this.micMute,
        camera_off: this.cameraOff,
      }
      console.log(callInformation)
      if (this.$native) {
        this.$native.event('phoneCallStartEvent', callInformation)
      }
      this.$emit('callStartedEvent')
    },

    toggleMute () {
      this.micMute = !this.micMute
    },

    toggleCamera () {
      this.cameraOff = !this.cameraOff
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/global.scss';
@import '@/assets/css/mediaQuery.scss';
@import '@/assets/css/colorTable.scss';

.prepare-call-view {
  .modal-body {
    display: flex;
    flex-direction: column;
    .information-block {
      height: calc(100vh - 260px);
      background-color: #aaa;
      overflow: auto;
      .sender-column {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 70px auto 20px;
        min-height: 47px;
        width: 250px;
        background-color: #fff;
        border-radius: 10px;
        .sender-name {
          width: calc(250px - 60px);
          margin-left: 10px;
          font-size: 26pt;
          &.large {
            font-size: 26pt;
          }
          &.middle {
            font-size: 20pt;
          }
          &.small {
            font-size: 14pt;
          }
        }
      }
      .arrow-column {
        margin: 0 auto;
        text-align: center;
        img {
          height: 47px;
        }
      }
      .attendees-column {
        margin: 20px auto;
        width: 310px;
        padding: 25px 30px;
        border-radius: 10px;
        background-color: #fff;
        .attendee-info {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          &.last {
            margin-bottom: 0;
          }
          .portrate-block {
            margin-right: 20px;
          }
          .name-block {
            .name {
              font-size: 28pt;
              &.large {
                font-size: 28pt;
              }
              &.middle {
                font-size: 22pt;
              }
              &.small {
                font-size: 16pt;
              }
            }
            .description {
              font-size: 13pt;
            }
          }
        }
      }
      .add-attendee-column {
        margin: 0 auto;
        padding: 8px 10px 5px;
        width: 160px;
        background-color: #fff;
        text-align: center;
        border-radius: 10px;
        color: $success-color;
      }
    }
    .controll-block {
      display: grid;
      grid-template-rows: 50% 50%;
      grid-template-columns: 50% 50%;
      justify-items: center;
      align-items: center;
      height: 260px;
      background-color: #eee;
      // padding: 30px;
      .cancel-controll {
        grid-row: 1 / 1;
        grid-column: 1 / 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-left: 30px;
        padding: 10px;
        img {
          width: 60px;
          height: 60px;
        }
        .caption {
          margin-top: 10px;
          font-size: 10pt;
        }
      }
      .start-call-controll {
        grid-row: 1 / 1;
        grid-column: 2 / 2;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-right: 30px;
        padding: 10px;
        img {
          width: 60px;
          height: 60px;
        }
        .caption {
          margin-top: 10px;
          font-size: 10pt;
        }
      }
      .mic-controll {
        grid-row: 2 / 2;
        grid-column: 1 / 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-left: 30px;
        padding: 10px;
        img {
          width: 60px;
          height: 60px;
        }
      }
      .camera-controll {
        grid-row: 2 / 2;
        grid-column: 2 / 2;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-right: 30px;
        padding: 10px;
        img {
          width: 60px;
          height: 60px;
        }
      }
    }
  }
}
</style>